import React, { useCallback } from "react";
import TextoInfoFarol from "../TextoInfoFarol";
import { useTranslations } from "adapters/i18n";

type ValorNascimento = {
  Coletas: {
    Categoria: string;
    DataColeta: string;
    PesoVisual: number;
    Quantidade: number;
  }[];
  Quantidade: number;
};

export type FarolPastoNascimento = {
  Cor: string | null;
  IdPasto: number;
  Valor: ValorNascimento | null;
};

export const MontaTextoTooltipNascimento = (
  title: string,
  farolPasto: FarolPastoNascimento
) => {
  const { t } = useTranslations();

  const constants = {
    categoria: t("animalCategory:category"),
    quantidade: t("common:amount"),
    pesoVisual: t("livestock:visual-weight"),
    data: t("common:collect-date"),
  };

  const textoComponente = useCallback(() => {
    let properties: { [key: string]: [string] }[] = [];

    if (farolPasto && farolPasto.Valor) {
      properties = farolPasto.Valor.Coletas.map((coleta) => ({
        [constants.categoria]: [coleta.Categoria],
        [constants.quantidade]: [coleta.Quantidade.toString()],
        [constants.pesoVisual]: [coleta.PesoVisual.toString()],
        [constants.data]: [new Date(coleta.DataColeta).toLocaleDateString()],
      }));
    }
    return (
      <TextoInfoFarol
        title={title}
        properties={properties}
        titleAdornmentColor={""}
      />
    );
  }, [title, farolPasto]);

  return () => textoComponente();
};
